import type { ComputedBlockStateUnionType } from '@unifyapps/defs/types/block';
import { type InterfaceEntity, InterfaceType } from '@unifyapps/defs/types/interface';
import type { InterfacePageEntity } from '@unifyapps/defs/types/page';
import { UA_ASSETS_PATH } from '@unifyapps/network/utils/PublicEnv/assetsCdn';
import _noop from 'lodash/noop';
import type { UserPermissionsMap } from '../access-control/types';
import BlockRenderer from '../components/BlockRenderer';
import type BlocksRegistry from '../context/RegistryProvider/BlocksRegistry';
import { DUMMY_INTERFACE_RECORD_ID, NO_INTERFACE_RECORD_ID } from './index';

export const DUMMY_BLOCK_STATE = {
  id: 'dummy_block_id',
};

export const EMPTY_PERMISSIONS: UserPermissionsMap = {};

/** Mimics an interface record when interfaceId is NO_INTERFACE_RECORD_ID (field/form builder); use for store and skip real fetches. */
export const NO_INTERFACE_RECORD: InterfaceEntity = {
  name: 'no-interface',
  entityType: 'e_interface',
  id: NO_INTERFACE_RECORD_ID,
  properties: {
    name: 'no-interface',
    standard: false,
    type: InterfaceType.Application,
    metadata: {
      logo: {
        small: `${UA_ASSETS_PATH}/theme/unifyapps/unify.svg`,
        large: `${UA_ASSETS_PATH}/theme/unifyapps/unify.svg`,
      },
    },
    navigation: {
      defaultPageId: '',
      primary: [],
    },
  },
};

export const DUMMY_INTERFACE_RECORD: InterfaceEntity = {
  name: 'dummy-interface-name',
  entityType: 'dummy-entity-type',
  id: DUMMY_INTERFACE_RECORD_ID,
  properties: {
    name: 'dummy-name',
    standard: false,
    type: InterfaceType.Application,
    metadata: {
      logo: {
        small: `${UA_ASSETS_PATH}/theme/unifyapps/unify.svg`,
        large: `${UA_ASSETS_PATH}/theme/unifyapps/unify.svg`,
        favicon: '/favicon.png',
      },
    },
    navigation: {
      defaultPageId: 'dummy-default-page-id',
      primary: [
        {
          type: 'GROUP' as const,
          id: 'dummy-nav-primary-id',
          name: 'dummy-nav-primary-name',
          icon: 'dummy-nav-primary-icon',
          items: [],
        },
      ],
    },
  },
};

const DUMMY_REGISTRY = {
  getBlockRenderer: BlockRenderer,
} as unknown as BlocksRegistry;

export const dummyBlockProps = {
  blockState: DUMMY_BLOCK_STATE,
  computedBlockState: DUMMY_BLOCK_STATE as ComputedBlockStateUnionType,
  registry: DUMMY_REGISTRY,
  updateBlockSessionState: _noop,
  updateBlockState: _noop,
};

export const getDummyPage = (properties: Record<string, unknown>): InterfacePageEntity => {
  return {
    id: 'page-id',
    entityType: 'e_component',
    deleted: false,
    version: 1,
    properties: {
      interfaceId: DUMMY_INTERFACE_RECORD.id,
      ...properties,
    },
  };
};
